import { useParams, useHistory } from 'react-router-dom'
import PageHeader from '../../components/layout/PageHeader'
import Location from '../../hooks/Location'
import { isSuperAdminTenant } from '../../utils/superAdminTenant'
import useInsight from '../../hooks/useInsight'
import useThemes from '../../hooks/useThemes'
import InsightEditor from '../../components/intelligence/InsightEditor'
import { themeTitle } from '../../helpers/intelligence/themeTitle'
import { themeDetailPath } from '../../helpers/intelligence/themeRoute'

/**
 * Eén inzicht op zijn eigen pagina: dezelfde redactie als op het celdetail.
 * De ouder is het thema (doelgroep × effect); een inzicht zonder thema bestaat
 * niet meer (besluit user 2026-09-14).
 *
 * De titel komt uit het bevroren thema als het inzicht gepubliceerd is, en
 * anders uit de levende themalijst — die twee kunnen verschillen na een
 * hernoeming, en voor een publicatie telt wat er buiten staat.
 *
 * AI-CONTEXT: See docs/features/intelligence-thema-eerst.md
 */
const InsightDetailContent = () => {
    const { insightId } = useParams()
    const history = useHistory()
    const client = Location()[1]

    const { insight, loading, loaded, error } = useInsight(insightId || '')
    const themes = useThemes()

    const naarThema = (themeId) => history.push(themeId ? themeDetailPath(client, themeId) : `/${client}/intelligence`)

    if (error) {
        return (
            <div className="main"><div className="main-container">
                <p className="intelligence-state intelligence-state--error">
                    Het inzicht kon niet worden geladen: {error.message}
                </p>
            </div></div>
        )
    }
    if (loading) {
        return (
            <div className="main"><div className="main-container">
                <p className="intelligence-state">Inzicht laden…</p>
            </div></div>
        )
    }
    // Pas beweren dat het inzicht niet bestaat als de read gelukt is.
    if (loaded && !insight) {
        return (
            <div className="main"><div className="main-container">
                <p className="intelligence-state">Dit inzicht bestaat niet (meer).</p>
                <button type="button" onClick={() => naarThema('')}>Terug naar Intelligence</button>
            </div></div>
        )
    }

    const bevroren = insight.Published && insight.Published.theme
    const levend = themes.themes.find((t) => t.id === insight.ThemeID)
    const thema = bevroren || levend || null
    const titel = thema ? themeTitle(thema) : (themes.loaded ? 'Thema niet gevonden' : 'Thema laden…')

    return (
        <div className="main">
            <div className="main-container">
                <PageHeader
                    heading={titel}
                    description={insight.Status === 'published' ? 'Gepubliceerd inzicht onder dit thema.' : 'Concept onder dit thema. Schrijf de tekst en publiceer.'}
                    AI={false}
                    actions={<button type="button" onClick={() => naarThema(insight.ThemeID)}>Terug naar het thema</button>}
                />
                {/* De redactie zelf staat ook op het celdetail; dit is de eigen
                    pagina van het inzicht, bereikbaar vanuit de publicaties. */}
                <InsightEditor
                    insight={insight}
                    themeTitle={titel}
                    onDeleted={() => naarThema(insight.ThemeID)}
                />
            </div>
        </div>
    )
}

/**
 * De poort staat om de inhoud heen: geen hook voor wie er niet hoort te zijn.
 * Weergavekeuze — de échte poort zit server-side op de Cloud Functions.
 * AI-CONTEXT: See docs/pitfalls.md#security-cf-admin-tenant-bypass
 */
const InsightDetail = () => {
    const client = Location()[1]
    if (!isSuperAdminTenant(client)) {
        return (
            <div className="main"><div className="main-container">
                <p className="intelligence-state">Deze pagina is alleen beschikbaar voor het Deccos-beheerteam.</p>
            </div></div>
        )
    }
    return <InsightDetailContent />
}

export default InsightDetail
